import React from "react";
import LinkButton from "../../../components/LinkButton";
import Spinner from "../../../components/Loader/Spinner";
import SearchRecordTable from "../../NewSearchRecords/SearchRecordTable";
import { useAuthState } from "../../../components/AuthProvider";

import styles from "./ReviewQueueCard.module.scss";
import { Switch, Route, Link } from "react-router-dom/cjs/react-router-dom.min";
const Card = ({
  name,
  isLoading: loading = true,
  noOfQueues,
  onClick,
  isDisabled = false,
  cardType = "Identities",
  searchOverlay,
  isQuarantine = false,
  isAllQuarantine = false,
  onClickSearch
}) => {
  const { user } = useAuthState();
  const [recordId, setRecordId] = React.useState();
  const [sourceSystemId, setSourceSystemId] = React.useState();
  const handleRecordIdChange = event => {
    setRecordId(event.target.value);
  };
  const handleSourceSystemIdChange = event => {
    setSourceSystemId(event.target.value);
  };
  return (
    <Switch>
      <Route
        path={`search-identities-new/:ms_clientId/quarantine/:quar_sourceId/:quar_recordId/`}
      >
        <SearchRecordTable />
      </Route>
      <div className={styles.base}>
        <div className={styles.queueHeading}>{name}</div>

        {searchOverlay && (
          <>
            <div className={styles.searchBoxDeatils}>
              <div>
                <input
                  type="text"
                  placeholder="Record ID"
                  onChange={handleRecordIdChange}
                />
              </div>
              <br />
              <div>
                <input
                  type="text"
                  placeholder="Source System"
                  onChange={handleSourceSystemIdChange}
                />
              </div>
              <div>
                {!isAllQuarantine ? (
                  <button
                    onClick={() =>
                      onClickSearch(recordId.trim(), sourceSystemId.trim())
                    }
                    disabled={!recordId || !sourceSystemId}
                  >
                    search
                  </button>
                ) : (
                  <Link
                    to={{
                      pathname: `/search-identities-new/${user.preferences.selectedClient.oid}/quarantine/${sourceSystemId}/${recordId}/`,
                      state: {
                        sourceSystemId: sourceSystemId,
                        recordId: recordId
                      }
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <button
                      onClick={() =>
                        onClickSearch(recordId.trim(), sourceSystemId.trim())
                      }
                      disabled={!recordId || !sourceSystemId}
                    >
                      search
                    </button>
                  </Link>
                )}
              </div>
            </div>
            <div className={styles.searchQueueDetails}>
              <div className={styles.queueDetail}>
                {!isDisabled && <span>{cardType}</span>}
                {loading ? (
                  <Spinner />
                ) : (
                  <>
                    <br />
                    <br />
                    <span style={{ fontWeight: "bold" }}>
                      {isDisabled ? "Not Subscribed" : noOfQueues}
                    </span>
                  </>
                )}
              </div>
              <br />
              {!isQuarantine && (
                <div className={styles.link}>
                  <LinkButton onClick={onClick} disabled={isDisabled}>
                    Enter Queue
                  </LinkButton>
                </div>
              )}
            </div>
          </>
        )}

        {!searchOverlay && (
          <>
            <div className={styles.queueDetail}>
              {!isDisabled && <span>{cardType}</span>}
              {loading ? (
                <Spinner />
              ) : (
                <span style={{ fontWeight: "bold" }}>
                  {isDisabled ? "Not Subscribed" : noOfQueues}
                </span>
              )}
            </div>
            <div className={styles.link}>
              <LinkButton onClick={onClick} disabled={isDisabled}>
                Enter Queue
              </LinkButton>
            </div>
          </>
        )}
      </div>
    </Switch>
  );
};

export default Card;
